<template>
  <div id="layout-default">
    <div class="sidebar-menu" ref="sidebarmenu">
      <div class="logo">
        <!-- <img src="../../assets/mktops_logo@2x.png"/> -->
        <img src="../../assets/mktops_logo_new.png" />
        <div class="logo-text">MKTOPS</div>
      </div>
      <div class="main-menu">
        <div class="header">
          <md-icon v-if="activeMenu">{{ activeMenu.icon }}</md-icon>
          <div v-if="activeMenu" style="text-transform: uppercase">
            {{ activeMenu.title }}
          </div>
        </div>
        <ul v-if="activeMenu">
          <!-- <li>{{user.acl}}</li> -->
          <li
            v-for="(m, idx) in activeMenu.sub"
            :key="idx"
            :class="{ active: isActive(m.title) }"
            v-if="checkSubmenuView(activeMenu, m) || user.username == 'admin'"
          >
            <router-link
              :to="m.url"
              @click.native="setActive(m.title, activeMenu)"
              :event="disabledMenu ? '' : 'click'"
              >{{ m.title }}</router-link
            >
            <label style="display: none">{{ checkDisabledMenu() }}</label>
          </li>
        </ul>
      </div>
      <div class="menu-icon">
        <!-- {{menu}} -->
        <ul>
          <li
            v-for="(item, idx2) in menu"
            :key="idx2"
            v-if="checkMainMenuView(item) || user.username == 'admin'"
          >
            <!-- {{user.acl[item.title.toLowerCase()]}} -->
            <router-link
              to=""
              class="icon-logo"
              @click.native="clickMenu(item.title)"
            >
              <!-- {{item}} -->
              <md-icon
                >{{ item.icon }}
                <md-tooltip md-direction="top">{{
                  tooltip(item.title, idx2)
                }}</md-tooltip>
                <!-- <span class="tooltiptext">{{item.title}}</span> -->
              </md-icon>
            </router-link>
          </li>
        </ul>
      </div>
      <div
        class="user-profile"
        @click="showMenu"
        @mouseleave="showProfileMenu = false"
      >
        <div class="image"></div>
        <div class="content">
          <span class="name">{{ user.firstname }}</span>
          <span class="team">MARKETING</span>
        </div>
        <div class="btn-profile">
          <!-- <md-menu md-direction="top-start">
                <md-button class="md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>

                <md-menu-content>
                  <md-menu-item>Profile</md-menu-item>
                  <md-menu-item>Sign out</md-menu-item>
                </md-menu-content>
              </md-menu> -->
        </div>

        <!-- <div v-if="user.acl.campaign.view">view</div>
        <div v-else>not view</div> -->

        <div class="user-profile-menu md-elevation-6" v-if="showProfileMenu">
          <ul>
            <li>
              <router-link to="#" @click.native="onLogout()">
                <md-icon>account_circle</md-icon>LOGOUT
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mkt-main-content" ref="mktmaincontent">
      <router-view></router-view>
    </div>

    <md-dialog-confirm
      :md-active.sync="alertChange"
      md-title="Confirm?"
      md-content="Are you sure you want to leave this page?"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirmalert"
    />
  </div>
</template>

<script>
export default {
  name: 'default-layout',
  data () {
    return {
      activeMenu: { icon: '', title: '' },
      activeItem: 'overview',
      showProfileMenu: false,
      alertChange: false,
      vMenu: 'create',
      vLogout: false,
      disabledMenu: false
    }
  },
  methods: {
    checkDisabledMenu () {
      this.disabledMenu = this.$store.getters['bookprice/clickRequestPage']
    },
    onCancel () {
      this.activeItem = this.vMenu
      this.alertChange = false
    },
    onConfirmalert () {
      this.disabledMenu = false
      this.$store.commit('bookprice/onClickRequestPage', false)

      if (this.vLogout) {
        this.$store.commit('pmcreate/clearPromotionCreate')
        this.$store.commit('pmcreate/setStep', 'step-1')

        this.$store.dispatch('auth/logout').then(() => {
          localStorage.removeItem('token')
          localStorage.removeItem('expires_date')
          this.$router.push('/login')
        })
      } else {
        this.$store.commit('pmcreate/clearPromotionCreate')
        this.$store.commit('pmcreate/setStep', 'step-1')

        if (this.activeMenu.url == '/promotion') {
          this.$router.push(this.activeItem)
        } else {
          for (let i = 0; i < this.activeMenu.sub.length; i++) {
            if (this.activeItem == this.activeMenu.sub[i].title) {
              this.$router.push(this.activeMenu.sub[i].url)
              return false
            }
          }
        }
      }

      this.alertChange = false
    },
    checkSubmenuView (activeMenu, menu) {
      if (
        this.user.acl[this.getModuleName(activeMenu.url)].menus[
          this.getMenuName(menu.url)
        ]
      ) {
        if (
          this.user.acl[this.getModuleName(activeMenu.url)].menus[
            this.getMenuName(menu.url)
          ].view == true
        ) {
          return true
        }
      }
      return false
    },
    checkMainMenuView (item) {
      if (this.use !== null) {
        if (this.user.acl[this.getModuleName(item.url)]) {
          if (this.user.acl[this.getModuleName(item.url)].view == true) {
            return true
          }
        }
      }
      return false
    },
    getModuleName (url) {
      return url.split('/')[1]
    },
    getMenuName (url) {
      return url.split('/')[2]
    },
    tooltip (text, index) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    clickMenu (menu) {
      //alert(menu);
      let m = this.menu.find(function (obj) {
        return obj.title === menu
      })
      //console.log(m);
      this.activeMenu = m
      this.activeItem = menu
    },
    showMenu (e) {
      // this.$refs['menu-profile'].style.display = 'block';
      this.showProfileMenu = true
    },
    setDefault () {
      if (this.user.username != 'admin') {
        var active = null
        var _self = this

        active = this.menu.filter(function (item) {
          if (_self.user.acl[_self.getModuleName(item.url)]) {
            if (_self.user.acl[_self.getModuleName(item.url)].view == true) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        })

        this.activeMenu = active[0]
      } else {
        this.activeMenu = this.menu[0]
      }
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem
    },
    setActive: function (menuItem, activeMenu) {
      if (activeMenu.url == '/promotion' && menuItem == 'create') {
        this.$store.commit('pmcreate/clearPromotionCreate')
        this.$store.commit('pmcreate/setStep', 'step-1')
      } else {
        let data_promotion = this.$store.getters['pmcreate/value']
        if (
          (data_promotion.promotion_code != '' &&
            data_promotion.promotion_code != null) ||
          (data_promotion.promotion_title != '' &&
            data_promotion.promotion_title != null) ||
          (data_promotion.promotion_detail != '' &&
            data_promotion.promotion_detail != null) ||
          (data_promotion.startdate != '' &&
            data_promotion.startdate != null) ||
          (data_promotion.enddate != '' && data_promotion.enddate != null)
        ) {
          this.alertChange = true
          this.$router.push('/promotion/create')
        }
      }

      if (activeMenu.url === '/setting' && menuItem !== 'Master Config') {
        // let data_master_config = this.$store.getters["setconfig/dataMasterConfig"];
        // console.log("data_master_config ==>", data_master_config);
        // let dataCampaign = this.$store.getters["setconfig/dataCampaign"];
        let update_data = this.$store.getters['setconfig/updateData']
        if (update_data === true) {
          this.alertChange = true
          this.$router.push('/setting/set-config')
        }
      }

      if (this.disabledMenu) {
        this.alertChange = true
      }

      this.activeItem = menuItem // no need for Vue.set()
    },
    onLogout () {
      let data_promotion = this.$store.getters['pmcreate/value']
      if (
        (data_promotion.promotion_code != '' &&
          data_promotion.promotion_code != null) ||
        (data_promotion.promotion_title != '' &&
          data_promotion.promotion_title != null) ||
        (data_promotion.promotion_detail != '' &&
          data_promotion.promotion_detail != null) ||
        (data_promotion.startdate != '' && data_promotion.startdate != null) ||
        (data_promotion.enddate != '' && data_promotion.enddate != null)
      ) {
        this.alertChange = true
        this.vLogout = true
      } else {
        // console.log(this.statusServer[0].messages=="online")
        this.$store.dispatch('auth/logout').then(() => {
          localStorage.removeItem('token')
          localStorage.removeItem('expires_date')
          localStorage.removeItem('row_request_price')
          localStorage.removeItem('click_book_price')
          localStorage.removeItem('user_activity')
          if (this.statusServer.length > 0) {
            if (this.statusServer[0].messages == 'online') {
              this.$router.push('/login')
            } else if (this.statusServer[0].messages == 'retest') {
              this.$router.push('/retest')
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$router.push('/login')
          }
        })
      }
    },
    hideReportSideBar () {
      if (
        this.$route.path === '/maintenance' ||
        this.$route.path === '/mkt/analize' ||
        this.$route.path === '/salesops' ||
        (this.$route.path === '/promotion/report' &&
          this.$route.query.user !== undefined)
      ) {
        this.$refs.sidebarmenu.style.display = 'none'
        this.$refs.mktmaincontent.style.paddingLeft = 0
      } else {
        this.$refs.sidebarmenu.style.display = 'block'
        this.$refs.mktmaincontent.style.paddingLeft = '150px'
      }
    }
  },
  computed: {
    menu () {
      return this.$store.getters['menu/menu']
    },
    user () {
      return this.$jwt.decode(localStorage.getItem('token'))
    },
    statusServer () {
      return this.$store.getters['statusServer']
    }
  },
  watch: {
    statusServer (val) {
      if (val.length > 0) {
        //   this.subTitle = val[1].messages;
        if (val[0].messages == 'offline') {
          localStorage.setItem('statusServer', val[0].messages)
          this.$store.dispatch('auth/logout').then(() => {
            //alert('logout');
            this.$router.push('/maintenance')
            // this.$router.push('/login')
          })
          //     // Vue.localStorage.set('test1', 'offline->mainteanace');
          //     localStorage.setItem("mainteanace_mode", "mainteanace_online");
          //     this.$router.replace("/overview/maintenance");
          //   } else if (val[0].messages == "reopen") {
          //     // Vue.localStorage.set('test2', 'reopen->mainteanace');
          //     location.reload();
          //     setTimeout(() => {
          //       this.$store.dispatch("setServer");
          //     }, 20);
          //   } else if (val[0].messages == "online") {
          //     localStorage.removeItem("mainteanace_mode");
          //     // Vue.localStorage.set('test3', 'online->mainteanace');
          //     // this.$router.replace("/");
        } else if (val[0].messages == 'online') {
          if (localStorage.getItem('statusServer') == null) {
            localStorage.setItem('statusServer', val[0].messages)
          } else if (localStorage.getItem('statusServer') == 'retest') {
            localStorage.setItem('statusServer', val[0].messages)
            this.$store.dispatch('auth/logout').then(() => {
              this.$router.push('/')
            })
          }
        } else if (val[0].messages == 'retest') {
          localStorage.setItem('statusServer', val[0].messages)
        } else {
          localStorage.setItem('statusServer', val[0].messages)
          this.$store.dispatch('auth/logout').then(() => {
            this.$router.push('/')
          })
        }
      }
    },
    menu: 'setDefault',
    $route: function (to, from) {
      this.hideReportSideBar()
    }
  },
  mounted () {
    this.hideReportSideBar()
  },
  created () {
    this.$store.dispatch('watchServer')
    this.$store.dispatch('menu/getMenu').then(res => {
      this.setDefault()
    })
  }
}
</script>

<style lang="scss" scoped>
.sidebar-menu {
  position: fixed;
  overflow: hidden;
  width: 150px;
  top: 0;
  left: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #3f51b5;
  display: block;
  text-align: center;

  font-family: Roboto;

  z-index: 2;

  .logo {
    margin-top: 15px;

    .logo-text {
      margin-top: 10px;
      color: white;
      font-size: 13px;
      letter-spacing: 2px;
    }
  }

  .main-menu {
    margin-top: 30px;
    height: 180px;

    .header {
      color: white;
      font-size: 12px;
      margin-bottom: 10px;
      letter-spacing: 1px;

      .md-icon {
        color: inherit;
        padding-bottom: 10px;
      }
    }

    ul {
      overflow: auto;
      list-style-type: none;
      top: 0;
      left: 0;
      margin: 0;
      padding: 0;
      height: 150px;

      /* width */
      &::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #8087af;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #2539ad;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #162577;
      }

      li {
        color: white;
        padding-bottom: 10px;
      }

      li a {
        font-size: 12px;
        color: white;
        opacity: 0.7;
        text-decoration: none;
        font-family: Roboto;
        font-weight: bold;
        letter-spacing: 1px;

        &:hover {
          opacity: 1;
          font-weight: 14px !important;
          // transition: 0.1s ease-out;
        }
      }

      li.active a {
        color: white;
        opacity: 1;
      }

      .md-icon {
        color: white;
      }
    }
  }

  .menu-icon {
    width: 150px;
    margin-top: 15px;
    ul {
      list-style-type: none;
      top: 0;
      left: 0;
      margin: 0;
      padding: 0;

      li {
        padding-bottom: 25px;
      }

      .icon-logo {
        .md-icon {
          color: white;
          opacity: 0.7;
          font-size: 18px !important;

          &:hover {
            opacity: 1;
            font-size: 36px !important;
            transition: 0.1s ease-out;
          }
        }
      }
    }
  }

  .user-profile {
    position: fixed;
    bottom: 0;
    width: 150px;
    height: 66px;
    background: #303f9f;
    color: white;
    padding: 20px;

    cursor: pointer;

    .btn-profile {
      position: absolute;
      right: 0;
      top: 5px;
      .md-icon {
        color: white;
      }
    }

    .user-profile-menu {
      // display:none;
      position: absolute;
      width: 100px;
      height: 50px;
      background: white;

      right: -100px;
      top: 10px;
      z-index: 10;

      color: black;

      ul {
        margin: 0;
        padding: 0;
        list-style-type: none;

        li {
          margin: 0;
          padding: 0;
        }

        li a {
          padding-top: 5px;
          margin-top: 10px;
          display: block;
          width: 100%;
          height: 32px;
          text-decoration: none;
          color: black;
          font-family: Roboto;
          font-size: 12px;

          .md-icon {
            color: black;
            margin-right: 5px;
          }

          &:hover {
            background: #817fff;
            // opacity: 0.5;
          }
        }
      }
    }

    .image {
      background: rgb(148, 148, 148);
      width: 32px;
      height: 32px;
      float: left;
      margin-right: 10px;
      border-radius: 50%;
      // border-right:2px solid #000;
    }
    .content {
      // overflow:hidden;
      padding-top: 5px;
      line-height: 12px;

      text-align: left;

      .name {
        display: block;
        font-size: 10px;
        font-weight: bold;
        font-family: Roboto;
      }
      .team {
        display: block;
        font-size: 10px;
        font-family: Roboto;
      }
    }
  }
}

.mkt-main-content {
  padding-left: 150px;
}

// .md-tooltip{
//   left:150px !important;
//   color:black !important;
//   background-color: white !important;
//   font-size:12px;
// }
// /* Tooltip container */
// .tooltip {
//     position: relative;
//     display: inline-block;
//     border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
// }

// /* Tooltip text */
// .tooltip .tooltiptext {
//     visibility: hidden;
//     width: 120px;
//     background-color: black;
//     color: #fff;
//     text-align: center;
//     padding: 5px 0;
//     border-radius: 6px;

//     /* Position the tooltip text - see examples below! */
//     position: absolute;
//     z-index: 1;
// }

// .tooltip .tooltiptext {
//     top: -5px;
//     left: 105%;
// }

// /* Show the tooltip text when you mouse over the tooltip container */
// .tooltip:hover .tooltiptext {
//     visibility: visible;

// }
</style>
